import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authconfig";
import { PublicClientApplication } from "@azure/msal-browser";
import HttpsRedirect from './Components/Shared/HttpsRedirect';

const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
  <HttpsRedirect>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </HttpsRedirect>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
